import FeedPatients from './feed-patients';

export default FeedPatients;
